import React, { useState } from 'react';
import * as XLSX from 'xlsx';
import axios from 'axios';
import { saveAs } from 'file-saver';

const ExcelProcessor = () => {
  const [isLoading, setIsLoading] = useState(false);

  const handleFileUpload = async (e) => {
    const file = e.target.files[0];
    const reader = new FileReader();

    reader.onload = async (event) => {
      setIsLoading(true);
      const data = new Uint8Array(event.target.result);
      const workbook = XLSX.read(data, { type: 'array' });

      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];
      const rows = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
      const headers = rows[0];
      const dataRows = rows.slice(1);

      const newRows = [ // encabezados + nuevos campos
        [...headers, 'puntuacion_ponderada', 'prediccion_ponderada', 'resultado_segmentacion']
      ];
      //dataRows.length
      for (let i = 0; i < 1001; i++) {
        const row = dataRows[i];

        // Armamos el JSON (ajusta índices si cambia el orden)
        const jsonPayload = {
          VARIABLES: {
            "STATUS_LD": row[0] || "",
            "HASOPTEDOUTOFEMAIL_LD": row[1],
            "CEN_DONDE_COMPRAR__C_LD": row[2] || "",
            "CEN_N_MERO_DE_DOCUMENTO__C_LD": row[3] || "",
            "CEN_ELIGE_DONDE_VIVIR__C_LD": row[4] || "",
            "CEN_FORMULARIO__C_LD": row[5] || "",
            "CEN_MEDIO__C_LD": parseInt(row[6]) || 0,
            "CEN_NACIONALIDAD__C_LD": row[7] || "",
            "CEN_T_RMINOS_Y_CONDICIONES__C_LD": row[8] || "",
            "CEN_TIPO_DE_DOCUMENTO__C_LD": row[9] || "",
            "CEN_UTM_SOURCE__C_LD": row[10] || "",
            "CEN_LONGITUD_DE_DOCUMENTO__C_LD": parseInt(row[11]) || 0,
            "CEN_ORDEROFPRIORITY__C_LD": parseInt(row[12])  || 0,
            "CEN_LEADREACTIVE__C_LD": row[13] || "",
            "CEN_ACEPTOPERFILAMIENTO__C_LD": row[14] || "",
            "CEN_ACEPTOENVIOPUBLICIDAD__C_LD": row[15] || "",
            "CEN_FECHA_HORA_DE_CREACION__C": row[16] || "",
            "USERNAME": row[17] || "",
            "Variable_42": parseInt(row[18]) || 0,
            "Variable_46": parseInt(row[19]) || 0,
            "Variable_50": parseInt(row[20]) || 0,
            "Variable_51": parseInt(row[21]) || 0,
            "Variable_53": parseInt(row[22]) || 0,
            "Variable_55": parseInt(row[23]) || 0,
            "Variable_59": parseInt(row[24]) || 0,
            "Variable_60": parseInt(row[25]) || 0,
            "Variable_63": parseInt(row[26]) || 0,
            "Variable_67": parseInt(row[27]) || 0,
            "Variable_68": parseInt(row[28]) || 0,
            "Variable_70": parseInt(row[29]) || 0,
            "Variable_76": parseInt(row[30]) || 0,
            "Variable_80": parseInt(row[31]) || 0,
            "Variable_86": parseInt(row[32]) || 0,
            "Variable_88": parseInt(row[33]) || 0,
            "Variable_97": parseFloat(row[34]) || 0,
            "Variable_104": parseInt(row[35]) || 0,
            "Variable_202": row[36] || "",
            "Variable_287": row[37] || "",
            "Variable_315": row[38] || "",
            "Variable_370": parseInt(row[39]) || 0,
            "Variable_749": parseInt(row[40]) || 0
          }
        };

        try {
          const res = await axios.post(
            `http://localhost:7071/api/http_trigger_leads?code=LVoc4cMjI5wNvTjvWi9T4N0V_qPnCMA9UePPMuvyBeiwAzFuyoODiA==`,
            jsonPayload,
            {
              headers: {
                'Content-Type': 'application/json'
              }
            }
          );

          const parsedInput = JSON.parse(res.data.input)[0];
          const { puntuacion_ponderada, prediccion_ponderada, resultado_segmentacion } = parsedInput;

          newRows.push([
            ...row,
            puntuacion_ponderada,
            prediccion_ponderada,
            resultado_segmentacion
          ]);
        } catch (err) {
          console.error(`Error en fila ${i + 1}`, err);
          newRows.push([...row, 'ERROR', 'ERROR', 'ERROR']);
        }
      }

      // Crear nuevo libro y hoja
      const newWorksheet = XLSX.utils.aoa_to_sheet(newRows);
      const newWorkbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(newWorkbook, newWorksheet, sheetName);

      // Guardar nuevo archivo
      const wbout = XLSX.write(newWorkbook, { bookType: 'xlsx', type: 'array' });
      saveAs(new Blob([wbout], { type: 'application/octet-stream' }), 'resultado_con_api.xlsx');
      setIsLoading(false);
    };

    reader.readAsArrayBuffer(file);
  };

  return (
    <div>
      <h2>Sube un archivo Excel para procesar</h2>
      <input type="file" accept=".xlsx, .xls" onChange={handleFileUpload} />
      {isLoading && <p>Procesando... por favor espera</p>}
    </div>
  );
};

export default ExcelProcessor;